module.exports = __webpack_public_path__ + "img/companyIntro7.447a6eda.png";